import apiClient  from '../utils/apiClient';

// Time Off Types
export const getTimeOffTypes = async () => {
  const response = await apiClient.get('api/timeoff/types');
  return response.data;
};

export const createTimeOffType = async (typeData) => {
  const response = await apiClient.post('api/timeoff/types', typeData);
  return response.data;
};

export const updateTimeOffType = async (id, typeData) => {
  const response = await apiClient.put(`api/timeoff/types/${id}`, typeData);
  return response.data;
};

export const deleteTimeOffType = async (id) => {
  const response = await apiClient.delete(`api/timeoff/types/${id}`);
  return response.data;
};

// Time Off Requests
export const getTimeOffRequests = async (params = {}) => {
  const response = await apiClient.get('api/timeoff/requests', { params });
  return response.data;
};

export const createTimeOffRequest = async (requestData) => {
  const response = await apiClient.post('api/timeoff/requests', requestData);
  return response.data;
};

export const updateTimeOffRequest = async (id, updateData) => {
  const response = await apiClient.put(`api/timeoff/requests/${id}`, updateData);
  return response.data;
};

export const cancelTimeOffRequest = async (id) => {
  const response = await apiClient.delete(`api/timeoff/requests/${id}`);
  return response.data;
};